import { lazy } from 'react';

/**
 * The layout and the two redirect/dispatch components are imported eagerly:
 * they are tiny, they render on every settings visit, and lazying the shell
 * would put a full-screen loader in front of a frame that is meant to persist.
 * The weight is in the sections, and each of those code-splits itself — see
 * `sections.tsx`.
 */
export { SettingsLayout, SettingsIndex } from './SettingsLayout';
export { SettingsSectionRoute } from './SettingsSectionRoute';

export const StaffDetailsPage = lazy(() =>
  import('./StaffDetailsPage').then((m) => ({ default: m.StaffDetailsPage })),
);

export const RoleEditorPage = lazy(() =>
  import('./RoleEditorPage').then((m) => ({ default: m.RoleEditorPage })),
);

export const ProcedureEditorPage = lazy(() =>
  import('./ProcedureEditorPage').then((m) => ({
    default: m.ProcedureEditorPage,
  })),
);
